export default __webpack_public_path__ + "static/partners-15482b0fde0988261a2b798942f7ff5b.mp4";